import {call} from 'redux-saga/dist/redux-saga-effects-npm-proxy.esm';
import {get, getManager, setManager} from './api';

export default (flows) => {
  flows.getFlow('get').setActions({
    onFetch: function* () {
      const {data} = yield call(() => get());

      return data;
    },
  });

  flows.getFlow('getManager').setActions({
    onFetch: function* () {
      const {data} = yield call(() => getManager());

      return data;
    },
  });

  flows.getFlow('setManager').setActions({
    onFetch: function* ({ payload }) {
      yield call(() => setManager(payload));
    },
  });

  return flows.getSagas();
};
